import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ProductosService 
{
    constructor(private http: HttpClient) { }

    obtieneProductos() 
    { 
        return this.http.get(`${environment.urlBase}/productos`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }
    obtieneAgrupadorProductos() 
    { 
        return this.http.get(`${environment.urlApipagos}/agrupacionproductos`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }
   
    cumpleCarencia(idProducto: any, rut: any)
    {
        return this.http.get(`${environment.urlBase}/productos/${idProducto}/carencia/rut/${rut}`, 
        { headers: this.armaCabecera(), params: { idProducto: idProducto, rut: rut } } ).toPromise();
    }

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}